import type { ComponentPropsWithoutRef } from 'react';

type ProseProps = ComponentPropsWithoutRef<'div'>;

export function Prose({ className, ...props }: ProseProps) {
  return (
    <div
      className={[
        'max-w-3xl text-base leading-7 text-muted-foreground',
        '[&_h2]:mt-12 [&_h2]:mb-4 [&_h2]:text-2xl [&_h2]:font-semibold [&_h2]:text-foreground',
        '[&_h3]:mt-8 [&_h3]:mb-3 [&_h3]:text-xl [&_h3]:font-semibold [&_h3]:text-foreground',
        '[&_p]:mb-4',
        '[&_a]:text-brand [&_a]:underline-offset-4 hover:[&_a]:underline',
        '[&_ul]:mb-4 [&_ul]:list-disc [&_ul]:ps-6',
        '[&_ol]:mb-4 [&_ol]:list-decimal [&_ol]:ps-6',
        '[&_code]:rounded [&_code]:bg-muted [&_code]:px-1.5 [&_code]:py-0.5 [&_code]:font-mono [&_code]:text-sm',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      {...props}
    />
  );
}
